<style lang="scss">
*, :after, :before {
  border: 0 solid #dae1e7;
}

.media-body textarea {
  resize: none;
}

$color-black: #000000;
$color-white: #ffffff;
$color-gray: #dddddd;

.editor {
  &__content {

    word-wrap: break-word;
    height: 100%;
    min-height: 160px;

    > div {
      min-height: 160px;
      outline: none;
    }

    * {
      caret-color: currentColor;
    }

    pre {
      padding: 0.7rem 1rem;
      border-radius: 5px;
      background: $color-black;
      color: $color-white;
      font-size: 0.8rem;
      overflow-x: auto;

      code {
        display: block;
      }
    }

    p.is-empty:first-child::before {
      content: attr(data-empty-text);
      float: left;
      color: #aaa;
      pointer-events: none;
      height: 0;
      font-style: italic;
    }

    p code {
      display: inline-block;
      padding: 0 0.4rem;
      border-radius: 5px;
      font-size: 0.8rem;
      font-weight: bold;
      background: rgba($color-black, 0.1);
      color: rgba($color-black, 0.8);
    }

    ul,
    ol {
      padding-left: 3rem;
    }

    li > p,
    li > ol,
    li > ul {
      margin: 0;
    }

    a {
      color: inherit;
    }

    blockquote {
      border-left: 3px solid rgba($color-black, 0.1);
      color: rgba($color-black, 0.8);
      padding-left: 0.8rem;
      font-style: italic;

      p {
        margin: 0;
      }
    }

    img {
      max-width: 100%;
      border-radius: 3px;
    }

    table {
      border-collapse: collapse;
      table-layout: fixed;
      width: 100%;
      margin: 0;
      overflow: hidden;

      td, th {
        min-width: 1em;
        border: 2px solid $color-gray;
        padding: 3px 5px;
        vertical-align: top;
        box-sizing: border-box;
        position: relative;

        > * {
          margin-bottom: 0;
        }
      }

      th {
        font-weight: bold;
        text-align: left;
      }

      .selectedCell:after {
        z-index: 2;
        position: absolute;
        content: "";
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(200, 200, 255, 0.4);
        pointer-events: none;
      }

      .column-resize-handle {
        position: absolute;
        right: -2px;
        top: 0;
        bottom: 0;
        width: 4px;
        z-index: 20;
        background-color: #adf;
        pointer-events: none;
      }
    }

    .tableWrapper {
      margin: 1em 0;
      overflow-x: auto;
    }

    .resize-cursor {
      cursor: ew-resize;
      cursor: col-resize;
    }
  }
}

.menubar {
  transition: visibility 0.2s 0.4s, opacity 0.2s 0.4s;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;

  &.is-hidden {
    visibility: hidden;
    opacity: 0;
  }

  &.is-focused {
    visibility: visible;
    opacity: 1;
    transition: visibility 0.2s, opacity 0.2s;
  }

  &__button {
    font-weight: bold;
    display: inline-flex;
    background: transparent;
    border: 0;
    color: $color-black;
    padding: 0.5rem;
    margin-right: 0.2rem;
    border-radius: 3px;
    cursor: pointer;
    outline: none;

    &:hover {
      background-color: rgba($color-black, 0.05);
    }

    &.is-active {
      background-color: rgba($color-black, 0.1);
    }
  }
}

.audio-preview-container audio {
  outline: 1px solid #afaeae;
  border-radius: 30px;
}

.replying-message-text {
  p {
    margin-bottom: 0;
  }
}

</style>

<template>
  <div class="panel panel-default flex flex-col h-full">
    <div class="panel-heading">
      <h3 class="panel-title text-left">
        Mensajería
      </h3>
    </div>
    <div class="panel-body flex-grow">
      <div class="tab-content">
        <div class="tab-pane active">
          <div class="form-group">
            <ul class="chat-history">
              <li class="chat-message-bubble relative shadow-sm" v-for="(mensaje, index) in mensajes" :id="mensaje.id"
                  :key="mensaje.id"
                  :class="{
                    'bg-yellow-100' : esDelCliente(mensaje) && mensaje.estado === 0,
                    'left': esDelCliente(mensaje),
                    'right': !esDelCliente(mensaje),
                    'bot': esDelBot(mensaje)
              }">

                <!-- Creacion de contenedor de reply que aparece encima del mensaje, solo si replying_id existe -->
                <div class="chat-message-bubble relative shadow-sm replying" v-if="mensaje.replying !== null">
                  <div class="replying-message-text cursor-pointer" @click="gotoMessage(mensaje.replying.id)">
                    <div class="nombre-mensaje flex-1">
                      {{ mensaje.replying.nombre }}
                    </div>
                    <span v-html="mensaje.replying.mensaje"></span>
                  </div>
                </div>

                <div>

                  <!-- Avatar del usuario -->
                  <div v-if="isLastMessageFromUser(mensaje)" class="pull-left">
                    <img class="img-circle" width="40px"
                         :alt="esDelBot(mensaje) ? 'Asistente Yamaha' : (esDelSistema(mensaje) ? 'Envío automático' : 'img')"
                         :title="esDelBot(mensaje) ? 'Respuesta automática del asistente' : (esDelSistema(mensaje) ? 'Cotización enviada automáticamente al entrar el lead' : null)"
                         v-bind:src="mensaje.avatar">
                  </div>

                  <!-- Contenido Mensaje -->
                  <div class="media-body body-mensaje">
                    <div class="flex items-center gap-x-2">
                      <div v-if="isLastMessageFromUser(mensaje)"
                           class="nombre-mensaje flex-1">{{ mensaje.nombre }}
                      </div>
                    </div>
                    <p class="texto-mensaje"
                       v-if="!(mensaje.mensaje === 'Archivo adjunto' && mensaje.adjuntos && mensaje.adjuntos.length > 0)"
                       v-html="mensaje.mensaje">
                    </p>

                    <!-- New Reply Button -->

                    <button
                      v-if="esVendedor && mensaje.id !== 0"
                      class="btn-reply absolute top-5"
                      :class="{
                        '-left-14' : !esDelCliente(mensaje),
                        '-right-14' : esDelCliente(mensaje)
                      }"
                      @click.prevent="setReplyingId(mensaje)"
                    >
                      <i class="far fa-reply fa-lg"
                         :class="{
                          'fa-flip-horizontal': !esDelCliente(mensaje),
                        }"></i><span class="tooltip">Responder a este mensaje</span>
                    </button>

                  </div>

                  <!-- Previsualizacion de archivos adjuntos -->
                  <div v-if="mensaje.adjuntos && mensaje.adjuntos.length > 0" class="mt-2">
                    <div class="flex flex-wrap">
                      <template v-for="adjunto in mensaje.adjuntos">
                        <div :key="adjunto.id" class="p-2 mx-2">
                          <a v-if="esImagen(adjunto.url)" target="_blank" :href="adjunto.url"
                             data-vue-fancybox :data-caption="adjunto.name"
                             class="relative block">
                            <img :src="adjunto.url" :alt="adjunto.name"
                                 class="w-64 h-64 object-cover transition-opacity duration-300 hover:opacity-75">
                            <div
                              class="absolute inset-0 bg-black bg-opacity-50 cursor-pointer flex items-center justify-center opacity-0 transition-opacity duration-300 hover:opacity-100">
                              <i class="fas fa-search text-white text-3xl"></i>
                            </div>
                          </a>

                          <div v-else-if="esPDF(adjunto.url)" class="relative">
                            <div :id="'pdf-preview-' + adjunto.id" class="chat-preview"></div>
                            <a :href="adjunto.url" target="_blank"
                               class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
                              <i class="fas fa-external-link-alt text-white text-3xl"></i>
                            </a>
                          </div>

                          <!-- Add this where you render attachments in your template -->
                          <div v-else-if="esAudio(adjunto.url)" :id="`audio-preview-${adjunto.id}`"
                               class="audio-preview-container" style="margin: 10px 0; width: 100%;">
                            <div class="audio-loading">Cargando reproductor de audio...</div>
                          </div>

                          <a v-else target="_blank" :href="adjunto.url">
                            <i class="fal fa-fw text-gray-700"
                               :class="obtenerIconoArchivo(adjunto.url)"></i>
                            {{ adjunto.name }}
                          </a>
                        </div>
                      </template>
                    </div>
                  </div>

                  <!-- Fecha y estado del mensaje -->
                  <div class="mt-2 flex items-center">
                    <span v-if="esDelCliente(mensaje) && mensaje.estado === 0"
                          class="chat-unread-message">Nuevo mensaje</span>

                    <div class="fecha-mensaje flex justify-end items-center flex-1">
                      <div>{{ mensaje.fecha_creacion | prettyDateV2 }}</div>
                      <div v-if="mensaje.canal === 'whatsapp'" class="ml-2">
                        <svg class="w-8 h-8 text-green-600"
                             fill="currentColor"
                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path
                            d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
                        </svg>
                      </div>
                    </div>
                  </div>

                </div>

              </li>
            </ul>
          </div>


          <!-- Contenedor Respuesta Cliente -->
          <div v-if="form.respondiendo" class="reply-box right relative shadow-sm">
            <div class="small text-gray-500">
              Respondiendo a:
            </div>

            <div class="nombre-mensaje flex-1">
              {{ form.respondiendo.nombre }}
            </div>

            <div v-html="form.respondiendo.mensaje"></div>

            <span @click="form.respondiendo = null" class="float-right absolute top-3 right-3 cursor-pointer">
              <i class="fal fa-fw fa-times"></i>
            </span>
          </div>

          <form
            v-show="cotizacionEnviada === true && ((puedeEnviarMensajes && !localCallbellContactId) || puedeEnviarMensajesCallbell)"
            ref="mensajeForm" enctype="multipart/form-data">
            <div class="form-group">
              <ul class="media-list">
                <li class="media" v-if="esVendedor">
                  <img class="img-circle pull-left" style="max-width: 50px" :src="usuario.avatar">

                  <div class="media-body body-mensaje">
                    <div class="editor">
                      <editor-menu-bar :editor="editor">
                        <div class="menubar p-2 bg-gray-100 border border-gray-200"
                             slot-scope="{ commands, isActive }">
                          <button class="menubar__button" title="Negrita"
                                  :class="{ 'is-active': isActive.bold() }"
                                  @click.prevent="commands.bold"
                          ><i class="fal fa-bold"></i></button>
                          <button class="menubar__button" title="Cursiva"
                                  :class="{ 'is-active': isActive.italic() }"
                                  @click.prevent="commands.italic"
                          ><i class="fal fa-italic"></i></button>
                          <button class="menubar__button" title="Tachar"
                                  :class="{ 'is-active': isActive.strike() }"
                                  @click.prevent="commands.strike"
                          ><i class="fal fa-strikethrough"></i></button>
                          <button class="menubar__button" title="Subrayar"
                                  :class="{ 'is-active': isActive.underline() }"
                                  @click.prevent="commands.underline"
                          ><i class="fal fa-underline"></i></button>

                          <!-- Headings -->
                          <button class="menubar__button" title="Encabezado de nivel 1"
                                  :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                                  @click.prevent="commands.heading({ level: 1 })"
                          ><i class="fal fa-h1"></i></button>
                          <button class="menubar__button" title="Encabezado de nivel 2"
                                  :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                                  @click.prevent="commands.heading({ level: 2 })"
                          ><i class="fal fa-h2"></i></button>
                          <button class="menubar__button" title="Encabezado de nivel 3"
                                  :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                                  @click.prevent="commands.heading({ level: 3 })"
                          ><i class="fal fa-h3"></i></button>

                          <!-- Lists -->
                          <button class="menubar__button" title="Lista"
                                  :class="{ 'is-active': isActive.bullet_list() }"
                                  @click.prevent="commands.bullet_list"
                          ><i class="fal fa-list-ul"></i></button>
                          <button class="menubar__button" title="Lista ordenada"
                                  :class="{ 'is-active': isActive.ordered_list() }"
                                  @click.prevent="commands.ordered_list"
                          ><i class="fal fa-list-ol"></i></button>

                          <button class="menubar__button" title="Deshacer"
                                  @click.prevent="commands.undo"
                          ><i class="fal fa-undo"></i></button>

                          <button class="menubar__button" title="Rehacer"
                                  @click.prevent="commands.redo"
                          ><i class="fal fa-redo"></i></button>
                        </div>
                      </editor-menu-bar>

                      <div class="block w-full bg-white text-xl p-4 m-0 outline-none border-l border-r">
                        <editor-content class="editor__content" :editor="editor"/>
                      </div>
                    </div>

                    <div class="border border-dashed text-center text-xl"
                         style="border-color: #c2cad8; border-bottom-left-radius: 5px !important; border-bottom-right-radius: 5px !important;">
                      <div class="p-8 hover:bg-gray-100 relative">

                        <input type="file" name="archivos" multiple
                               @change="actualizarListadoArchivos($event.target.files)"
                               :disabled="form.sending"
                               class="absolute opacity-0 w-full h-full inset-0 cursor-pointer"/>

                        <div v-show="!(form.sending && form.archivos.length > 0)" class="cursor-pointer">
                          <i class='fal fa-cloud-upload'></i>
                          Puede adjuntar archivos arrastrándolos o haciendo click aquí.
                        </div>

                        <div v-show="form.sending && form.archivos.length > 0">
                          <i class='fal fa-spin fa-spinner'></i> Cargando archivos, espere un momento...

                          <div class="shadow w-full bg-gray-400 mt-2">
                            <div class="bg-teal text-lg leading-none py-1 text-center text-white"
                                 :style="`max-width: 100%; width: ${form.uploadPercentage}%`">
                              {{ form.uploadPercentage }}%
                            </div>
                          </div>
                        </div>

                      </div>

                      <div v-for="(file, index) in form.archivos" :key="file.id"
                           class="flex items-center px-2 py-4 border-gray-400 hover:bg-gray-100 text-left leading-normal"
                           :class="{'border-t': index === 0, 'border-b' : index !== form.archivos.length - 1, 'border-b-0': index === form.archivos.length - 1}"
                      >
                        <!-- Icon / Preview -->
                        <div class="flex-shrink">
                          <i class="fal fa-2x text-gray-700"
                             :class="obtenerIconoArchivo(file)"></i>
                        </div>
                        <!-- Nombre del archivo -->
                        <div class="flex-grow mx-4">
                          <div class="flex flex-col">
                            <div class="text-xl">{{ file.name }}</div>
                            <div class="text-lg text-gray-600">
                              Tamaño: <span class="font-semibold"> {{ file.size | formatBytes }}</span>
                            </div>
                            <div v-show="!tieneTamanoPermitido(file)">
                              <div class="text-red-600 border-l-4 border-red-600 bg-red-100 p-2 my-1">
                                El tamaño no puede ser superior a <span
                                class="font-semibold">{{ MAX_FILE_SIZE }} MB</span>. El archivo no se cargará.
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Remover archivo -->
                        <div class="flex-shrink flex">
                          <button @click.prevent="removerArchivo(index)"
                                  class="text-xl bg-white text-gray-800 border border-gray-400 hover:text-red-600 hover:border-red-600 py-1 px-2 mr-2 outline-none">
                            <i class="fal fa-fw fa-trash-alt text-red"></i> Eliminar
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </li>
              </ul>
            </div>
          </form>

          <div v-if="cotizacionEnviada === false && solicitudType === 'SCM'" class="note note-info">
            <h4 class="block">Para habilitar la mensajería primero debe enviar la cotización</h4>
            <p v-if="esVendedor">
              Haga click en el botón "<a data-toggle="modal" data-target="#modalCotizacionPDF">Enviar cotización</a>".
            </p>
          </div>

          <div v-if="cotizacionEnviada === true && esVendedor && localCallbellContactId && !puedeEnviarMensajesCallbell"
               class="note note-info">
            <h4 class="block">Conversación fuera de la política de las 24 horas de WhatsApp</h4>
            Para contactar al usuario utiliza alguna de las acciones pre-definidas o espera hasta que el
            usuario te envíe un nuevo mensaje.
          </div>
        </div>
      </div>
    </div>
    <div class="panel-footer flex gap-x-2 justify-end">
      <!-- Acciones pre-definidas para reanudar una conversación en Callbell (WhatsApp) -->
      <div v-if="cotizacionEnviada === true && esVendedor && localCallbellContactId" class="flex-1">
        <a class="btn blue-sharp"
           :disabled="enviandoMensajePredefinidoCallbell"
           data-toggle="modal" data-target="#modalCotizacionPDF">
          Re-enviar Cotización 🏍️
        </a>
        <div class="btn-group dropup">
          <a
            :disabled="enviandoMensajePredefinidoCallbell"
            class="btn blue-sharp dropdown-toggle" data-toggle="dropdown">
            Fichas Técnicas ⚙️
            <i class="fa fa-angle-up"></i>
          </a>
          <ul class="dropdown-menu" style="max-height: 250px; overflow: auto">
            <li v-if="productoEcommerce">
              <a class="bold"
                 @click.prevent="enviarMensajePredefinidoCallbell('FICHA_TECNICA', { 'modelo_id': productoEcommerce.id })">
                {{ productoEcommerce.nombre }}
              </a>
            </li>
            <li>
              <hr class="my-2"/>
            </li>
            <li v-for="otroProducto in otrosProductosEcommerce" :key="otroProducto.id">
              <a
                @click.prevent="enviarMensajePredefinidoCallbell('FICHA_TECNICA', { 'modelo_id': otroProducto.id })">
                {{ otroProducto.nombre }}
              </a>
            </li>
          </ul>
        </div>
        <a type="button" class="btn blue-sharp"
           :disabled="enviandoMensajePredefinidoCallbell"
           @click.prevent="enviarMensajePredefinidoCallbell('SEGUIMIENTO')">
          Seguimiento 💬
        </a>
        <a type="button" class="btn blue-sharp"
           :disabled="enviandoMensajePredefinidoCallbell"
           @click.prevent="enviarMensajePredefinidoCallbell('SALUDAR')">
          Saludar 👋🏻
        </a>

        <span v-if="errorMensajePredefinidoCallbell !== null" class="font-red">
          {{ errorMensajePredefinidoCallbell }}
        </span>
        <span v-if="enviandoMensajePredefinidoCallbell">
          <i class="fal fa-spin fa-spinner"></i> Enviando...
        </span>
      </div>

      <button
        v-show="cotizacionEnviada === true && esVendedor && ((puedeEnviarMensajes && !localCallbellContactId) || puedeEnviarMensajesCallbell)"
        class="btn blue-sharp"
        @click.prevent="enviarMensaje"
        :class="{'opacity-50 cursor-not-allowed' : !form.mensaje || form.mensaje.length === 0 || form.sending }"
        :disabled="!form.mensaje || form.mensaje.length === 0 || form.sending">
        <span v-if="form.sending"><i class="fal fa-spin fa-spinner"></i> Enviando...</span>
        <span v-else>Enviar</span>
      </button>

      <div v-if="cotizacionEnviada === false && esVendedor && solicitudType === 'SCM'" class="text-right">
        <a class="btn blue-sharp"
           data-toggle="modal" data-target="#modalCotizacionPDF">
          Enviar cotización
        </a>
      </div>

    </div>
  </div>
</template>

<script>
import filesize from 'filesize';
import {Editor, EditorContent, EditorMenuBar, EditorMenuBubble} from 'tiptap';
import {
  Bold,
  BulletList,
  HardBreak,
  Heading,
  History,
  HorizontalRule,
  Italic,
  Link,
  ListItem,
  OrderedList,
  Placeholder,
  Strike,
  Underline
} from 'tiptap-extensions';
import PDFObject from 'pdfobject';

export default {
  components: {
    EditorContent,
    EditorMenuBar,
    EditorMenuBubble,
  },
  props: {
    ticket: {type: String, required: true},
    solicitudId: {type: String, required: true},
    solicitudType: {type: String, required: true},
    usuario: {type: Object, required: true},
    cotizacionEnviada: {type: Boolean, required: true},
    esVendedor: {type: Boolean, required: true},
    callbellContactId: {type: String, required: false},
    usaCallbell: {type: Number, required: false},
    urlFichaTecnica: {type: String, required: false},
    productoEcommerce: {type: Object, required: false},
    otrosProductosEcommerce: {type: Array, required: false},
  },

  filters: {
    formatBytes(bytes) {
      return filesize(bytes);
    }
  },

  data() {
    return {
      idsNoLeidos: [],
      MAX_FILE_SIZE: 2, // Tamaño máximo en MB
      editor: new Editor({
        extensions: [
          new BulletList(),
          new HardBreak(),
          new Heading({levels: [1, 2, 3]}),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new BulletList(),
          new Bold(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History(),
          new Placeholder({
            emptyClass: 'is-empty',
            emptyNodeText: 'Escriba un mensaje...',
          }),
        ],
        onUpdate: ({getHTML}) => {
          this.form.mensaje = getHTML();
        }
      }),
      form: {
        mensaje: null,
        archivos: [],
        respondiendo: null,
        dragAndDropCapable: false,
        sending: false,
        uploadPercentage: 0,
      },
      mensajes: [],
      puedeEnviarMensajes: true,
      puedeEnviarMensajesCallbell: false,
      enviandoMensajePredefinidoCallbell: false,
      errorMensajePredefinidoCallbell: null,
      localCallbellContactId: this.callbellContactId,
      callbellInterval: null,
      estadoPollingCallbellCortado: false,
      callbellSinAcceso: false,

      audioContext: null,
      soundBuffer: null,
    }
  },

  watch: {
    callbellContactId(newVal) {
      this.localCallbellContactId = newVal;
    },

    mensajes: {
      handler() {
        this.cargarPrevisualizacionesPDF();
        this.cargarPrevisualizacionesFancybox();
        this.cargarPrevisualizacionesAudio();
      },
      deep: true
    }
  },

  methods: {
    async initAudio() {
      if (this.audioContext && this.soundBuffer) {
        return;
      }

      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();

      try {
        const response = await fetch("/sounds/new_message.wav");
        const arrayBuffer = await response.arrayBuffer();
        this.soundBuffer = await this.audioContext.decodeAudioData(arrayBuffer);
      } catch (error) {
        console.error("Error loading sound:", error);
      }
    },

    playNotification() {
      if (!this.soundBuffer || !this.audioContext) return;

      if (this.audioContext.state === "suspended") {
        this.audioContext.resume(); // Resume audio context if suspended
      }

      const source = this.audioContext.createBufferSource();
      source.buffer = this.soundBuffer;
      source.connect(this.audioContext.destination);
      source.start();
    },

    handleVisibilityChange() {
      // Ensure audio resumes when tab is active
      if (this.audioContext && document.visibilityState === "visible") {
        this.audioContext.resume();
      }
    },

    actualizarEstadoMensajes() {
      if (!this.esVendedor) {
        return;
      }

      this.mensajes.forEach((mensaje) => {
        if (mensaje.estado === 0 && this.esDelCliente(mensaje)) {
          this.idsNoLeidos.push(mensaje.id);
        }
      });

      if (this.idsNoLeidos.length > 0) {
        axios.patch(`api/cotizacion/mensajes/marcar-leidos`, {ids: this.idsNoLeidos.join(',')})

        /*
        setTimeout(() => {
          this.idsNoLeidos.forEach((id) => {
            this.mensajes.forEach(mensaje => {
              if (mensaje.id === id) {
                mensaje.estado = 1;
              }
            });
          })
        }, 10000);
        */
      }
    },

    enviarMensaje() {
      // Evita envíos duplicados por múltiples clicks
      if (this.form.sending) {
        return;
      }

      const formData = this.getFormData();

      this.form.sending = true;

      axios.post(`api/cotizacion/${this.ticket}/mensajes`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (progressEvent) => {
            this.form.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
          }
        }
      ).then(response => {
        if (response.data.created) {
          Notificaciones.showToastr('Mensajería', 'El mensaje se envió correctamente', 'success');

          if (this.idsNoLeidos.length > 0) {
            this.mensajes.forEach(mensaje => {
              if (this.idsNoLeidos.includes(mensaje.id)) {
                mensaje.estado = 1;
              }
            });

            this.idsNoLeidos = [];
          }

          // El mensaje puede haber llegado antes por el evento Echo mensaje.created
          if (this.mensajes.findIndex(m => m.id === response.data.mensaje.id) === -1) {
            this.mensajes.push(response.data.mensaje);
          }

          this.form.archivos = [];
          this.form.mensaje = '';
          this.form.respondiendo = null;

          this.editor.clearContent(true);
        } else {
          Notificaciones.showToastr('Mensajería', 'El mensaje no se pudo enviar', 'error');
        }
      }).catch(err => {
        Notificaciones.showToastr('Ups!', err, 'error');
      }).then(() => {
        this.form.sending = false;
        this.form.uploadPercentage = 0;
      });
    },

    gotoMessage(id) {
      // Try to find the element by id and scroll to it smoothly
      this.$nextTick(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({behavior: 'smooth', block: 'center'});
          // Optionally, highlight the message briefly
          el.classList.add('ring', 'ring-yellow-400');
          setTimeout(() => {
            el.classList.remove('ring', 'ring-yellow-400');
          }, 1200);
        }
      });
    },

    getFormData() {
      let formData = new FormData();

      if (this.form.archivos.length > 0) {
        this.form.archivos.forEach((file, index) => {
          if (this.tieneTamanoPermitido(file)) {
            formData.append('archivos[' + index + ']', file);
          }
        });
      }

      formData.append('solicitud_id', this.solicitudId);
      formData.append('solicitud_type', this.solicitudType);
      formData.append('user_id', this.usuario.id);
      formData.append('mensaje', this.form.mensaje);

      // Agregar el ID del mensaje al que se está respondiendo
      if (this.form.respondiendo) {
        formData.append('replying_id', this.form.respondiendo.id);
      }

      return formData;
    },

    setReplyingId(mensaje) {
      this.form.respondiendo = mensaje; // Save the replying ID
      console.log(`Replying to message ID: ${mensaje.id}`); // Optional: For debugging
    },

    removerArchivo(index) {
      this.form.archivos.splice(index, 1);
    },

    determineDragAndDropCapable() {
      const div = document.createElement('div');
      return (('draggable' in div)
          || ('ondragstart' in div && 'ondrop' in div))
        && 'FormData' in window
        && 'FileReader' in window;
    },

    /**
     * BIT-1654: el bot de Eclectic no tiene usuario, así que user_id null ya no
     * basta para saber que escribió el cliente. Los mensajes previos no traen
     * origen y se siguen distinguiendo por user_id.
     */
    esDelCliente(mensaje) {
      return mensaje.origen ? mensaje.origen === 'cliente' : mensaje.user_id === null;
    },

    esDelBot(mensaje) {
      return mensaje.origen === 'bot';
    },

    /**
     * BIT-1803: la cotización que YLM envía sola al entrar el lead.
     */
    esDelSistema(mensaje) {
      return mensaje.origen === 'sistema';
    },

    isLastMessageFromUser(mensaje) {
      // El bot y el sistema no tienen usuario: se agrupan por su origen
      if (this.esDelBot(mensaje) || this.esDelSistema(mensaje)) {
        const lastMessageFromSameOrigin = this.mensajes.findLast((m) => m.origen === mensaje.origen);

        return lastMessageFromSameOrigin && lastMessageFromSameOrigin.id === mensaje.id;
      }

      if (mensaje.user_id) {
        const lastMessageFromUser = this.mensajes.findLast((m) => {
          return m.user_id === mensaje.user_id;
        });

        return lastMessageFromUser && lastMessageFromUser.id === mensaje.id;
      }

      // Cliente, o vendedor/equipo sin usuario (lead sin vendedor asignado)
      const esDelCliente = this.esDelCliente(mensaje);
      const lastMessageFromSameSide = this.mensajes.findLast((m) => {
        return !m.user_id && !this.esDelBot(m) && !this.esDelSistema(m) && this.esDelCliente(m) === esDelCliente;
      });

      return lastMessageFromSameSide && lastMessageFromSameSide.id === mensaje.id;
    },

    obtenerIconoArchivo(file) {
      const imagesTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
      const excelTypes = ['xls', 'xlsx'];
      const wordTypes = ['doc', 'docx', 'rtf'];
      const powerpointTypes = ['ppt', 'pptx'];

      let classIcon = 'fa-file';

      const name = file.name || file;
      const ext = this.extensionDeUrl(name);

      if (imagesTypes.includes(ext)) {
        classIcon = 'fa-file-image';
      } else if (excelTypes.includes(ext)) {
        classIcon = 'fa-file-excel';
      } else if (wordTypes.includes(ext)) {
        classIcon = 'fa-file-word';
      } else if (powerpointTypes.includes(ext)) {
        classIcon = 'fa-file-powerpoint';
      } else if (ext === 'pdf') {
        classIcon = 'fa-file-pdf';
      }

      return classIcon;
    },

    // Los adjuntos de WhatsApp vienen con URL firmada (BIT-1408): la extensión
    // se toma del path, sin la query (?expires=...&signature=...)
    extensionDeUrl(url) {
      return url.split(/[?#]/)[0].split('.').pop().toLowerCase();
    },

    esImagen(url) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
      return imageExtensions.includes(this.extensionDeUrl(url));
    },

    esPDF(url) {
      return this.extensionDeUrl(url) === 'pdf';
    },

    esAudio(url) {
      const audioExtensions = ['mp3', 'wav', 'ogg', 'opus', 'm4a', 'aac'];
      return audioExtensions.includes(this.extensionDeUrl(url));
    },

    cargarPrevisualizacionesPDF() {
      this.$nextTick(() => {
        this.mensajes.forEach(mensaje => {
          if (mensaje.adjuntos) {
            mensaje.adjuntos.forEach(adjunto => {
              if (!this.esPDF(adjunto.url)) {
                return;
              }

              const pdfWrapperId = `pdf-preview-${adjunto.id}`;
              const pdfWrapper = document.getElementById(pdfWrapperId);

              // Verifica si pdfWrapper tiene la clases pdf-preview-ok
              if (!pdfWrapper || pdfWrapper.classList.contains('pdf-preview-ok')) {
                return;
              }

              // Si no la tiene, inicializa el PDF
              pdfWrapper.classList.add('pdf-preview-ok');

              PDFObject.embed(adjunto.url, pdfWrapper, {
                height: '100%',
                width: '100%',
                pdfOpenParams: {
                  view: 'FitV',
                  page: '1'
                }
              });
            });
          }
        });
      });
    },

    cargarPrevisualizacionesFancybox() {
      this.$nextTick(() => {
        const fancyboxLinkImages = document.querySelectorAll('.chat-history a[data-vue-fancybox]:not(.img-preview-ok)');

        fancyboxLinkImages.forEach((a) => {
          try {
            a.classList.add('img-preview-ok');
          } catch (err) {
          }
        });

        if (fancyboxLinkImages.length > 0) {
          $(fancyboxLinkImages).fancybox();
        }
      });
    },

    cargarPrevisualizacionesAudio() {
      this.$nextTick(() => {
        this.mensajes.forEach(mensaje => {
          if (mensaje.adjuntos) {
            mensaje.adjuntos.forEach(adjunto => {
              if (!this.esAudio(adjunto.url)) {
                return;
              }

              const audioWrapperId = `audio-preview-${adjunto.id}`;
              const audioWrapper = document.getElementById(audioWrapperId);

              // Verifica si audioWrapper tiene la clase audio-preview-ok
              if (!audioWrapper || audioWrapper.classList.contains('audio-preview-ok')) {
                return;
              }

              // Si no la tiene, inicializa el reproductor de audio
              audioWrapper.classList.add('audio-preview-ok');

              // Crear el elemento de audio
              const audioElement = document.createElement('audio');
              audioElement.controls = true;
              audioElement.src = adjunto.url;

              // Limpiar el contenedor y agregar el elemento de audio
              audioWrapper.innerHTML = '';
              audioWrapper.appendChild(audioElement);
            });
          }
        });
      });
    },

    actualizarListadoArchivos(files) {
      if (!files.length) return;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (!this.esDuplicado(file)) {
          this.form.archivos.push(file);
        }
      }
    },

    esDuplicado(file) {
      return this.form.archivos.findIndex(f => {
        return f.name === file.name && f.size === file.size;
      }) !== -1;
    },

    tieneTamanoPermitido(file) {
      return file.size / 2e+6 <= this.MAX_FILE_SIZE;
    },

    obtenerMensajes() {
      axios.get(`api/cotizacion/${this.ticket}/mensajes`)
        .then(response => {
          this.mensajes = response.data.mensajes;

          // Marca los mensajes no leídos como leídos al cargar el componente
          this.actualizarEstadoMensajes();
        });
    },

    obtenerContactoLead() {
      return axios.get(`api/callbell/contacto-lead/${this.ticket}`)
        .then(response => {
          if (response.data.contact) {
            this.localCallbellContactId = response.data.contact.uuid;
          }
        });
    },

    verificarEstadoConversacionCallbell(desdeInterval = false) {
      if (!this.esVendedor) {
        return;
      }

      // BIT-1689: tras un 401/403/404/419 ninguna consulta de Callbell puede
      // prosperar hasta recargar la página (sesión expirada, CSRF vencido,
      // sin permiso sobre el lead o lead inexistente), así que tampoco se lanzan las
      // verificaciones deliberadas (mensaje entrante por Echo, envío de un
      // predefinido): cada una sería otro error seguro en producción.
      if (this.callbellSinAcceso) {
        return;
      }

      // Si no existe el contacto en Callbell, se permite enviar mensajes (es comunicación fuera de Callbell)
      if (!this.usaCallbell) {
        this.puedeEnviarMensajes = true;
        this.puedeEnviarMensajesCallbell = false;
        return;
      }

      if (!this.localCallbellContactId) {
        this.puedeEnviarMensajes = true;
        this.puedeEnviarMensajesCallbell = false;

        // Sin UUID local: se consulta y, si el proveedor tiene contacto, se
        // re-verifica de inmediato con el UUID ya disponible en vez de esperar
        // el próximo tick del polling (el status check de 24 horas quedaba
        // hasta ~20 s con estado obsoleto tras enviar un template).
        this.obtenerContactoLead().then(() => {
          if (this.localCallbellContactId) {
            // BIT-1689: se propaga desdeInterval para que el guard del éxito
            // tardío también cubra esta cadena si el polling se cortó en vuelo.
            this.verificarEstadoConversacionCallbell(desdeInterval);
          }
        })
        // BIT-1466: mismo contrato que el status check — si la consulta del
        // contacto falla (419/500/fallo de red), el polling se corta en vez
        // de quedar pegado al endpoint que falla (observación del ci-review:
        // este camino quedaba fuera del corte).
        .catch(err => {
          this.detenerPollingCallbell(err);
        });

        return;
      }

      axios.get(`api/callbell/status-conversacion-whatsapp/${this.ticket}`)
        .then(response => {
          // BIT-1466: éxito tardío tras un corte por error: el estado terminal
          // aprobado (fail-quiet, último valor) no se deshace por una consulta
          // del interval que ya estaba en vuelo cuando el polling se cortó.
          // Las verificaciones deliberadas (p. ej. la que sigue al envío de un
          // mensaje predefinido) siguen escribiendo: su request nace después
          // del corte y refleja estado fresco (observación del ci-review).
          if (desdeInterval && this.estadoPollingCallbellCortado) {
            return;
          }
          this.puedeEnviarMensajesCallbell = response.data.can_send_messages || false;
        })
        .catch(err => {
          // BIT-1466: ante 401/403/419/500 o fallo de red el interval quedaba
          // pegado al endpoint que falla (polling zombie). Se corta sin
          // recargar la página y sin reintentos (mismo corte que BIT-1093).
          // BIT-1689: en producción una sesión expirada (401) y un usuario sin
          // permiso (403) seguían consultando cada 10 s durante horas.
          this.detenerPollingCallbell(err);
        });
    },

    detenerPollingCallbell(err) {
      // BIT-1466: mecánica única de corte del polling de Callbell, espejo de
      // la de cargas_externas.js (BIT-1093). Política aprobada: fail-quiet —
      // se conserva el último valor de puedeEnviarMensajesCallbell; el envío
      // lo valida el endpoint por su cuenta, así que ante un fallo transitorio
      // no se adivina el estado de la ventana de 24 horas. Ojo: el flag sí
      // gobierna el v-show del composer, así que si quedó en false el composer
      // sigue oculto; lo reabre la verificación que dispara un mensaje
      // entrante por Echo (ver listener de mensaje.created) o el envío de un
      // mensaje predefinido; tras un 401/403/404/419 solo lo reabre un envío
      // de predefinido exitoso o recargar la página (BIT-1689). El corte marca el flag para que un éxito tardío
      // del interval no deshaga el estado terminal.
      if (this.callbellInterval !== null) {
        clearInterval(this.callbellInterval);
        this.callbellInterval = null;
      }
      this.estadoPollingCallbellCortado = true;

      // BIT-1689: un error de autenticación, autorización o un lead que ya no
      // resuelve (404 de solicitudAccesiblePorTicket) no es transitorio; a
      // diferencia de un 500 o un fallo de red, deja el corte en terminal
      // también para las verificaciones deliberadas.
      const status = err && err.response ? err.response.status : null;
      if ([401, 403, 404, 419].includes(status)) {
        this.callbellSinAcceso = true;
      }
    },

    enviarMensajePredefinidoCallbell(tipoMensaje, extra) {
      this.enviandoMensajePredefinidoCallbell = true;
      this.errorMensajePredefinidoCallbell = null;

      axios.post(`api/callbell/mensaje-predefinido/${this.ticket}/${tipoMensaje}`, {
        extra: extra || {}
      }).then(response => {
        Notificaciones.showToastr('Mensajería', 'El mensaje se envió correctamente', 'success');

        // El mensaje puede haber llegado antes por el evento Echo mensaje.created
        if (this.mensajes.findIndex(m => m.id === response.data.mensaje.id) === -1) {
          this.mensajes.push(response.data.mensaje);
        }

        // El envío pudo haber creado un contacto nuevo en el proveedor (p.ej. lead
        // antiguo de Callbell migrado a Eclectic): se vuelve a consultar el UUID
        // vigente para que el status check de la ventana de 24 horas funcione.
        // BIT-1689: un envío exitoso prueba que la sesión y el permiso volvieron,
        // así que se levanta el corte terminal; si no, la re-verificación
        // saldría temprano con el UUID ya en null y la UI caería al modo sin
        // Callbell (composer libre, sin plantillas ni aviso de 24 horas).
        this.callbellSinAcceso = false;
        this.localCallbellContactId = null;
        this.verificarEstadoConversacionCallbell();
      })
        .catch(err => {
          let mensajeError = 'Ocurrió un error al enviar el mensaje';

          if (err.response) {
            mensajeError = err.response.data.error || mensajeError;
          }

          this.errorMensajePredefinidoCallbell = mensajeError;
        })
        .finally(() => {
          this.enviandoMensajePredefinidoCallbell = false;
        });
    },
  },

  mounted() {
    this.form.dragAndDropCapable = this.determineDragAndDropCapable();
    if (this.form.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(evt => {
        this.$refs.mensajeForm.addEventListener(evt, e => {
          e.preventDefault();
          e.stopPropagation();
        }, false);
      });

      this.$refs.mensajeForm.addEventListener('drop', e => {
        // Con un envío en curso los archivos soltados se ignoran (igual que el
        // input file deshabilitado): el .then del envío vacía form.archivos y
        // un archivo agregado a mitad de camino se perdería sin subirse
        if (this.form.sending) {
          return;
        }

        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          const file = e.dataTransfer.files[i];
          if (!this.esDuplicado(file)) {
            this.form.archivos.push(file);
          }
        }
      });
    }

    document.addEventListener("click", async () => {
      await this.initAudio();
    });

    // Escucha eventos de Laravel Echo para actualizar los mensajes en tiempo real
    Echo.channel('cotizacion.mensajes.' + this.ticket)
      .listen('.mensaje.created', (response) => {
        const mensaje = response.mensaje;
        if (!mensaje) {
          return;
        }

        //console.log("Nuevo mensaje recibido", mensaje);

        // Verificar si mensaje.id existe dentro de this.mensajes. Si no existe, lo agrega
        if (this.mensajes.findIndex(m => m.id === mensaje.id) === -1) {
          this.mensajes.push(mensaje);

          this.playNotification();
        }

        // BIT-1466: con el polling cortado, puedeEnviarMensajesCallbell queda
        // congelado y, si valía false, el composer sigue oculto aunque el
        // cliente acabe de reabrir la ventana de 24 horas al escribir. Un
        // mensaje del cliente es justo el hecho que cambia ese estado (el del
        // bot no, BIT-1654), así que dispara una verificación deliberada: una
        // sola consulta por mensaje, no un reintento; si vuelve a fallar, el
        // corte es idempotente.
        if (this.estadoPollingCallbellCortado && this.esDelCliente(mensaje)) {
          this.verificarEstadoConversacionCallbell();
        }

        // Marca los mensajes no leídos como leídos
        this.actualizarEstadoMensajes();
      });
  },

  created() {
    this.obtenerMensajes();
    this.verificarEstadoConversacionCallbell();

    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    // Trae nuevos mensajes cada 5 segundos
    /*
    setInterval(() => {
      this.obtenerMensajes();
    }, 5000);
    */

    // Verifica cada 10 segundos si el vendedor puede enviar mensajes a WhatsApp
    // BIT-1466: el handle se guarda para que detenerPollingCallbell pueda
    // cortar el polling ante el primer fallo del endpoint.
    this.callbellInterval = setInterval(() => {
      this.verificarEstadoConversacionCallbell(true);
    }, 10000);
  },

  beforeDestroy() {
    this.editor.destroy();

    // BIT-1466: el interval sobrevivía a la destrucción del componente sin
    // reload de por medio (leak preexistente); con el handle guardado, el
    // corte en destroy cierra ese camino.
    this.detenerPollingCallbell();

    // BIT-1689: con el corte marcado, un listener de Echo vivo tras destruir el
    // componente consultaría el status por cada mensaje del cliente.
    Echo.channel('cotizacion.mensajes.' + this.ticket).stopListening('.mensaje.created');

    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }
}
</script>



// WEBPACK FOOTER //
// resources/vue/components/cotizacion/MensajeriaCotizacion.vue